import script from "./setMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./setMessage.vue?vue&type=script&setup=true&lang=js"

import "./setMessage.vue?vue&type=style&index=0&id=ba579fa6&lang=scss&scoped=true"

import exportComponent from "D:\\a-mydemo\\houlang\\gs-demo\\keymemo-demo\\keymemory-pc-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba579fa6"]])

export default __exports__